// Falls back to publisherId (stringified) when pubId is absent — undefined
// (not the string "undefined") when neither field is present, so callers can
// still tell a real id apart from a missing one.
function getPubId(publisher) {
    return publisher.pubId ?? (publisher.publisherId != null ? String(publisher.publisherId) : undefined);
}

// This shape's industry data may arrive as a singular `industry` string
// instead of an `industries` array — normalize to always be an array.
function getPubIndustries(publisher) {
    if (publisher.industries?.length) return publisher.industries;
    return publisher.industry ? [publisher.industry] : [];
}

// manage-my-ecal-bff's ToPublicPublisherResponses shape (discover-publishers,
// featured-publishers, near-me, trending-near-me) is a raw publisher record —
// publisherId instead of pubId, a singular industry string instead of an
// industries array, no actionButton — not the richer card shape the UI reads
// (and that whats-hot's own ToWhatsHotPublisherResponses already provides).
export function normalizePublicPublisher(publisher) {
    return {
        ...publisher,
        pubId: getPubId(publisher),
        industries: getPubIndustries(publisher),
        actionButton: publisher.actionButton || 'Sync to Calendar',
    };
}

export function normalizePublicPublishers(publishers) {
    return publishers.map(normalizePublicPublisher);
}
